import { AlertChakra } from '@wow/alert'
import { AvatarChakra } from '@wow/avatar'
import { BadgeChakra } from '@wow/badge'
import { ButtonChakra } from '@wow/button'
import { CheckboxChakra  } from '@wow/checkbox'
import { CloseButtonChakra } from '@wow/close-button'
import { Divider } from '@wow/divider'
import { SpinnerChakra } from '@wow/progress-indicator'
import { themeChakra } from '@wow/themes'
import { ToastComponent } from '@wow/toast'
import { TooltipChakra } from '@wow/tooltip'
import { WebBeacon } from '@wow/web-beacon'

import styles from './styles'
import alert from './components/alert'
import input from './components/input'
import checkbox from './components/checkbox'
import select from './components/select'

// Fonts variants from Fontsource
import '@fontsource/red-hat-display/400.css';
import '@fontsource/red-hat-display/500.css';
import '@fontsource/red-hat-display/700.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/400.css';

const colors = {
  ...themeChakra.colors
}

const textStyles = {
  ...themeChakra.textStyles
}

const sizes = {
  ...themeChakra.sizes,  
}

const components = {
  ...input,
  ...alert,
  ...checkbox,
  ...select,
  Alert: AlertChakra,
  Avatar: AvatarChakra,
  Badge: BadgeChakra,
  Button: ButtonChakra,
  Checkbox: CheckboxChakra,
  CloseButton: CloseButtonChakra,
  Divider,
  Spinner: SpinnerChakra,
  Toast: ToastComponent,
  Tooltip: TooltipChakra,
  WebBeacon,  
}

const themeData = { 
  colors, 
  components, 
  textStyles, 
  styles, 
  sizes, 
  ...themeChakra.breakpoints,
  ...themeChakra.fonts,
  ...themeChakra.fontSizes, 
  ...themeChakra.fontWeights, 
  ...themeChakra.layerStyles, 
  ...themeChakra.letterSpacings, 
  ...themeChakra.lineHeights, 
  ...themeChakra.radii,
  ...themeChakra.shadows, 
  ...themeChakra.space
}


export default themeData
